import users from 'api/users'
import auth from 'api/auth'
import cookies from 'utilities/cookies'
import * as types from '../mutation-types'
import * as namedTypes from '../namespaced-mutation-types'

const Promise = window.Promise || require('promise')

export const updateUserAvatarData = ({ commit, rootState }, data) => {
  commit(types.USER_DATA, data)
  try {
    window.sessionStorage.setItem('debutUserData', JSON.stringify(data))
  } catch (e) {}
}

export const updateUserData = ({ commit, rootState }, data) => {
  if (rootState.users.token !== '') {
    return users.updateById(rootState.users.userData.id,
      rootState.users.token,
      data
    ).then((data) => {
      commit(types.USER_DATA, data.user)
      commit(types.USER_TOKEN, data.token)
      try {
        window.sessionStorage.setItem('debutToken', data.token)
        window.sessionStorage.setItem('debutUserData', JSON.stringify(data.user))
      } catch (e) {}
      return Promise.resolve(data)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const updateAccount = ({ commit, rootState }, data) => {
  if (rootState.users.token !== '') {
    return users.updateById(
      rootState.users.userData.id,
      rootState.users.token,
      data
    ).then((data) => {
      commit(types.USER_DATA, data.user)
      try {
        window.sessionStorage.setItem('debutUserData', JSON.stringify(data.user))
      } catch (e) {}
      return Promise.resolve(data)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const recruitVacancies = ({ commit, rootState }, data) => {
  if (rootState.users.token !== '') {
    return users.recruit(rootState.users.token, data)
      .then(() => {
        commit(types.USER_RECRUITED, {})
        return Promise.resolve()
      }, () => {
        return Promise.reject({
          status: 'err',
          messages: 'User recruit failed.'
        })
      })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const userSaveVacancy = ({ commit, rootState }, payload) => {
  if (rootState.users.token !== '') {
    if (payload.saved) {
      return users.addSaved(rootState.users.token, 'vacancy', {
        id: payload.id,
        userId: rootState.users.userData.id
      }).then(() => {
        let vacancies = JSON.parse(JSON.stringify(rootState.vacancies.vacancies))
        if (typeof vacancies !== 'undefined') {
          if (typeof vacancies.items !== 'undefined') {
            vacancies.items = vacancies.items.map(item => {
              if (item.id === payload.id) {
                item.isSaved = true
              }
              return item
            })
            commit(namedTypes.VACANCIES, vacancies, { root: true })
          }
        }

        let entry = JSON.parse(JSON.stringify(rootState.vacancies.entry))
        if (typeof entry !== 'undefined') {
          entry.isSaved = true
          commit(namedTypes.VACANCY_ENTRY, entry, { root: true })
        }
        return Promise.resolve()
      })
    } else {
      if (typeof payload.vacancies === 'undefined') {
        payload.vacancies = [payload.id]
      }
      return users.deleteSaved(rootState.users.token, 'vacancy', {
        vacancies: payload.vacancies,
        userId: rootState.users.userData.id
      }).then(() => {
        let vacancies = JSON.parse(JSON.stringify(rootState.vacancies.vacancies))
        if (typeof vacancies !== 'undefined') {
          if (typeof vacancies.items !== 'undefined') {
            vacancies.items = vacancies.items.map(item => {
              if (payload.vacancies.indexOf(item.id) > -1) {
                item.isSaved = false
              }
              return item
            })
            commit(namedTypes.VACANCIES, vacancies, { root: true })
          }
        }

        let entry = JSON.parse(JSON.stringify(rootState.vacancies.entry))
        if (typeof entry !== 'undefined') {
          if (payload.vacancies.indexOf(entry.id) > -1) {
            entry.isSaved = false
            commit(namedTypes.VACANCY_ENTRY, entry, { root: true })
          }
        }
        return Promise.resolve()
      })
    }
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const updateSavedVacancies = ({ commit }, data) => {
  commit(types.USER_SAVED_VACANCIES, data)
}

export const fetchSavedVacancies = ({ commit, rootState }, params = { page: 1 }) => {
  if (rootState.users.token !== '') {
    return users.getSaved(rootState.users.token, 'vacancy', params).then((data) => {
      commit(types.USER_SAVED_VACANCIES, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      if (typeof err.results !== 'undefined') {
        commit(types.USER_SAVED_VACANCIES, {})
      }
      return Promise.reject(err)
    })
  } else {
    commit(types.USER_SAVED_VACANCIES, {})
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}
export const updateUserRecruitedCategories = ({ commit, rootState }, payload) => {
  let categories = JSON.parse(JSON.stringify(rootState.users.recruitedCategories))
  if (typeof payload.reset !== 'undefined') {
    categories = categories.map(category => {
      category.checked = false
      if (typeof category.children !== 'undefined') {
        if (category.children.length > 0) {
          category.children = category.children.map(children => {
            children.checked = false
            return children
          })
        }
      }
      return category
    })
  } else {
    categories = categories.map(category => {
      if (typeof category.checked === 'undefined') {
        category.checked = false
      }
      if (category.id === payload.categoryId) {
        category.checked = payload.categoryStatus || false
      }
      if (typeof category.children !== 'undefined') {
        if (category.children.length > 0) {
          category.children = category.children.map(children => {
            if (typeof children.checked === 'undefined') {
              children.checked = false
            }
            if (children.id === payload.childrenId) {
              children.checked = payload.childrenStatus || false
            }
            return children
          })
        }
      }
      return category
    })
  }
  commit(types.USER_RECRUITED_CATEGORIES, categories)
}
export const updateUserRecruitedCompanies = ({ commit, rootState }, payload) => {
  let companies = JSON.parse(JSON.stringify(rootState.users.recruitedCompanies))
  if (typeof payload.reset !== 'undefined') {
    companies = companies.map(company => {
      company.checked = false
      return company
    })
  } else {
    companies = companies.map(company => {
      if (typeof company.checked === 'undefined') {
        company.checked = false
      }
      if (company.id === payload.companyId) {
        company.checked = payload.status || false
      }
      return company
    })
  }
  commit(types.USER_RECRUITED_COMPANIES, companies)
}
export const updateSavedrecruited = ({ commit, rootState }, data) => {
  commit(types.USER_RECRUITED, data)
}
export const deleteRecruited = ({ commit, rootState }, payload) => {
  if (rootState.users.token !== '') {
    return users.removeRecruited(rootState.users.token, {
      userId: rootState.users.userData.id,
      recruited: payload.recruited
    }).then(() => {
      return Promise.resolve()
    }, () => {
      return Promise.reject()
    })
  } else {
    commit(types.USER_RECRUITED, {})
    commit(types.USER_RECRUITED_CATEGORIES, {})
    commit(types.USER_RECRUITED_COMPANIES, {})
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}
export const fetchUserRecruited = ({ commit, rootState }, params = { page: 1 }) => {
  if (rootState.users.token !== '') {
    if (typeof rootState.users.recruited.current === 'undefined') {
      params = Object.assign({}, params, {
        fetchAllCompanies: true,
        fetchAllCategories: true
      })
    }
    if (typeof params.force !== 'undefined' &&
      params.force === true
    ) {
      params = Object.assign({}, params, {
        fetchAllCompanies: true,
        fetchAllCategories: true
      })
    }
    return users.getRecruited(rootState.users.token, params).then((data) => {
      commit(types.USER_RECRUITED, data.results)

      if (typeof data.results.categories !== 'undefined') {
        commit(types.USER_RECRUITED_CATEGORIES, data.results.categories.map(category => {
          category.checked = false
          return category
        }))
      }
      if (typeof data.results.companies !== 'undefined') {
        commit(types.USER_RECRUITED_COMPANIES, data.results.companies.map(company => {
          company.checked = false
          return company
        }))
      }
      return Promise.resolve(data.results)
    }, (err) => {
      if (typeof err.results !== 'undefined') {
        commit(types.USER_RECRUITED, {})
        if (typeof err.results.categories !== 'undefined') {
          commit(types.USER_RECRUITED_CATEGORIES, err.results.categories)
        }
        if (typeof err.results.companies !== 'undefined') {
          commit(types.USER_RECRUITED_COMPANIES, err.results.companies)
        }
      }
      return Promise.reject(err)
    })
  } else {
    commit(types.USER_RECRUITED, {})
    commit(types.USER_RECRUITED_CATEGORIES, {})
    commit(types.USER_RECRUITED_COMPANIES, {})
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const toggleFolderEditable = ({ commit, state }, id = -1) => {
  const folderIndex = state.folders.findIndex(folder => {
    return folder.id === id
  })
  if (folderIndex > -1) {
    let folders = JSON.parse(JSON.stringify(state.folders))
    folders[folderIndex].editable = !folders[folderIndex].editable
    commit(types.USER_FOLDERS, folders)
  }
}

export const addSavedToFolder = ({ commit, rootState }, data) => {
  if (rootState.users.token !== '') {
    return users.addSavedToFolder(rootState.users.token, {
      folderId: data.id || 0,
      userId: rootState.users.userData.id,
      vacancies: data.vacancies
    }).then((data) => {
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const updateUserFolder = ({ commit, rootState }, data) => {
  if (rootState.users.token !== '') {
    return users.updateFolder(rootState.users.token, {
      folderId: data.id || 0,
      userId: rootState.users.userData.id,
      name: data.name,
      parent: data.parent || 0,
      type: data.type || 'update'
    }).then((data) => {
      commit(types.USER_FOLDERS, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchUserFolders = ({ commit, rootState }) => {
  if (rootState.users.token !== '') {
    return users.getFolders(rootState.users.token).then((data) => {
      data.results = data.results.map(folder => {
        folder.editable = false
        return folder
      })
      commit(types.USER_FOLDERS, data.results)
      return Promise.resolve(data.results)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    commit(types.USER_FOLDERS, [])
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchUserData = ({ commit, rootState }) => {
  if (rootState.users.token !== '') {
    return users.get(rootState.users.token).then((data) => {
      commit(types.USER_DATA, data.user)
      commit(types.USER_TOKEN, data.token)
      try {
        window.sessionStorage.setItem('debutToken', data.token)
        window.sessionStorage.setItem('debutUserData', JSON.stringify(data.user))
      } catch (e) {}
      return Promise.resolve(data)
    }, (err) => {
      commit(types.USER_DATA, {})
      commit(types.USER_TOKEN, '')
      cookies.remove('debutToken')
      try {
        window.sessionStorage.removeItem('debutToken')
        window.sessionStorage.removeItem('debutUserData')
      } catch (e) {}
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const fetchUserProfileData = ({ commit, rootState }, userId) => {
  if (rootState.users.token !== '') {
    return users.getById(userId, rootState.users.token).then((data) => {
      return Promise.resolve(data)
    }, (err) => {
      return Promise.reject(err)
    })
  } else {
    return Promise.reject({
      status: 'err',
      messages: 'User token does not exists.'
    })
  }
}

export const forgotPassword = ({ commit }, loginData) => {
  return auth.forgotPassword(loginData).then((data) => {
    return Promise.resolve(data)
  }, (err) => {
    return Promise.reject(err)
  })
}

export const register = ({ commit }, signupData) => {
  return auth.register(signupData).then((data) => {
    commit(types.USER_DATA, data.user)
    commit(types.USER_TOKEN, data.token)
    cookies.set('debutToken', data.token, { expires: 86400 })
    try {
      window.sessionStorage.setItem('debutToken', data.token)
    } catch (e) {}
    return Promise.resolve(data)
  }, (err) => {
    commit(types.USER_DATA, {})
    commit(types.USER_TOKEN, '')
    cookies.remove('debutToken')
    try {
      window.sessionStorage.removeItem('debutToken')
      window.sessionStorage.removeItem('debutUserData')
    } catch (e) {}
    return Promise.reject(err)
  })
}

export const logout = ({ commit }) => {
  commit(types.USER_DATA, {})
  commit(types.USER_TOKEN, '')
  cookies.remove('debutToken')
  try {
    window.sessionStorage.removeItem('debutToken')
    window.sessionStorage.removeItem('debutUserData')
  } catch (e) {}
  return Promise.resolve()
}

export const reSentActiveAccountEmail = ({ commit, rootState }) => {
  return users.reSentActiveAccountEmail(rootState.users.token).then((data) => {
    return Promise.resolve()
  }, () => {
    return Promise.reject()
  })
}

export const activeUserAccount = ({ commit }, payload) => {
  return auth.activeUserAccount(payload).then((data) => {
    commit(types.USER_DATA, data.user)
    commit(types.USER_TOKEN, data.token)
    cookies.set('debutToken', data.token, { expires: 86400 })
    return Promise.resolve(data)
  }, (err) => {
    commit(types.USER_DATA, {})
    commit(types.USER_TOKEN, '')
    cookies.remove('debutToken')
    try {
      window.sessionStorage.removeItem('debutToken')
      window.sessionStorage.removeItem('debutUserData')
    } catch (e) {}
    return Promise.reject(err)
  })
}

export const setToken = ({ commit }, token) => {
  commit(types.USER_TOKEN, token)
}
export const setUserData = ({ commit }, data) => {
  commit(types.USER_DATA, data)
}

export const login = ({ commit }, loginData) => {
  return auth.login(loginData).then((data) => {
    commit(types.USER_DATA, data.user)
    commit(types.USER_TOKEN, data.token)
    commit(namedTypes.TOGGLE_LOGIN_ALERT, {
      isShow: true,
      isSucceeded: true
    }, {
      root: true
    })
    cookies.set('debutToken', data.token, { expires: 86400 })
    try {
      window.sessionStorage.setItem('debutToken', data.token)
      window.sessionStorage.setItem('debutUserData', JSON.stringify(data.user))
    } catch (e) {}
    return Promise.resolve(data)
  }, (err) => {
    commit(types.USER_DATA, {})
    commit(types.USER_TOKEN, '')
    cookies.remove('debutToken')
    try {
      window.sessionStorage.removeItem('debutToken')
      window.sessionStorage.removeItem('debutUserData')
    } catch (e) {}
    return Promise.reject(err)
  })
}



// WEBPACK FOOTER //
// ./src/vuex/users/actions.js